import {getOffersApiConfig, __VOYAGER__} from './../../../config/api-config';
import {defaultVertical, defaultFlavour} from '../../../config/app-config';

export const prepareGetOffersApiRequest = () => {
  let url = `${__VOYAGER__}`;
  const includeFieldsList = `&include_fields=${encodeURIComponent(
    JSON.stringify(['url', 'img_url', 'sub_heading', 'validity_text', 'slug']),
  )}`;
  url += `/api/${getOffersApiConfig.version}/pagemaker/get_personalized_chunk_offers_data/?chunk=home_carousel&vertical=${defaultVertical}&flavour=${defaultFlavour}&include_fields=${includeFieldsList}&mode=${getOffersApiConfig.mode}`;
  return url;
};
